import { render, staticRenderFns } from "./home_product_2.vue?vue&type=template&id=0f096ec6&scoped=true"
import script from "./home_product_2.vue?vue&type=script&lang=js"
export * from "./home_product_2.vue?vue&type=script&lang=js"
import style0 from "./home_product_2.vue?vue&type=style&index=0&id=0f096ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f096ec6",
  null
  
)

export default component.exports